module.exports = __webpack_public_path__ + "static/media/team20.8e0f2b36.png";